module.exports = __webpack_public_path__ + "static/media/library_icon.d60aa8ac.svg";